import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// La app no se amplía en ningún dispositivo (18/10/2026):
// - Safari en iPhone/iPad ignora user-scalable=no: se cancela el pellizco.
// - PC: se cancelan Ctrl/Cmd + rueda o pellizco del trackpad y Ctrl/Cmd + "+", "-", "0".
const sinZoom = (e) => e.preventDefault();
document.addEventListener("gesturestart", sinZoom, { passive: false });
document.addEventListener("gesturechange", sinZoom, { passive: false });
document.addEventListener("touchmove", (e) => {
  if (e.touches.length > 1) e.preventDefault();
}, { passive: false });
window.addEventListener("wheel", (e) => {
  if (e.ctrlKey || e.metaKey) e.preventDefault();
}, { passive: false });
window.addEventListener("keydown", (e) => {
  if ((e.ctrlKey || e.metaKey) && ["+", "-", "=", "0", "_"].includes(e.key)) e.preventDefault();
});

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .catch((error) => console.log("Service Worker error:", error));
  });
}
